import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { APP_DEFAULT_PATH } from 'config';
import useAuth from 'contexts/AuthContext';

// Keeps non-admin users out of the admin pages (defense in depth — the API
// enforces this too via IsPlatformAdmin).
export default function AdminGuard({ children }) {
  const { user } = useAuth();
  if (user && user.role !== 'admin') return <Navigate to={APP_DEFAULT_PATH} replace />;
  return children;
}

AdminGuard.propTypes = { children: PropTypes.node };
